export function getPayloadData(isVisible) {
  return { visible_to_tenant: !isVisible }
}

export function getButtonTooltipTextKey(isVisible) {
  return isVisible
    ? 'TaskTable.MarkAsInvisibleKey'
    : 'TaskTable.MarkAsVisibleKey'
}
